import { styled } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

export const Paragraph = styled(Typography)(({ theme: { spacing } }) => ({
  '& + .MuiTypography-root': {
    marginTop: spacing(2),
  },
}))
